module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfBxc4EsA.8badd6c6.woff2";